import { useFormContext } from 'src/lib/templates';

export const useConfirmAccountFormContext = () =>
  useFormContext<{
    checkCode: string;
  }>();
